import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PlanCarreraIndividualServices from "./PlanCarreraIndividual.service";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const clearPlanCarreraIndividual = () => async (dispatch) => {
  dispatch({
    type: actions.GET_PLAN_CARRERA,
    payload: {
      planCarrera: null,
    },

  });
}

export const getPlanCarreraIndividual = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLAN_CARRERA,
      payload: true,
    });
    const resp = await PlanCarreraIndividualServices.getCursosComparacion(filters);

    dispatch({
      type: actions.GET_PLAN_CARRERA,
      payload: {
        planCarrera: resp.data,
      },

    });
    dispatch({
      type: actions.PLAN_CARRERA_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.PLAN_CARRERA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_CARRERA,
      payload: false,
    });
  }
};

export const getInfoEncabezado = (filters) => async (dispatch) => {
  debugger
  dispatch({
    type: actions.LOADING_INFO_ENCABEZADO,
    payload: true,
  });
  const resp = await PlanCarreraIndividualServices.getEncabezadoPlanCarrera(filters);

  dispatch({
    type: actions.GET_INFO_ENCABEZADO,
    payload: {
      infoEncabezado: resp.data,
    },

  });
  dispatch({
    type: actions.LOADING_INFO_ENCABEZADO,
    payload: false,
  });

};

export const saveCoursePlanCarreraIndividual =
  (data, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN_CARRERA,
        payload: true,
      });
      debugger
      await PlanCarreraIndividualServices.addCursosColaborador(data);
      const resp = await PlanCarreraIndividualServices.getCursosComparacion(filters);

      dispatch({
        type: actions.GET_PLAN_CARRERA,
        payload: {
          planCarrera: resp.data
        },
      });
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN_CARRERA,
        payload: false,
      });
    }
  };


export const savePlanCarreraIndividual =
  (data) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN_CARRERA,
        payload: true,
      });
      const resp = await PlanCarreraIndividualServices.createCursosComparacion(data);
      dispatch({
        type: actions.GET_PLAN_CARRERA,
        payload: {
          planCarrera: resp.data
        },
      });
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: "",
      });

    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN_CARRERA,
        payload: false,
      });
    }
  };

export const editPlanCarreraIndividual =
  (data, id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_CARRERA,
        payload: true,
      });
      debugger
      const resp = await PlanCarreraIndividualServices.editCursosComparacion(id, data);
      const { planCarrera } = getState().planCarreraIndividual;
      let _planCarrera = planCarrera
      const item = resp.data.cursos_titulares_creados.find((item) => item.id === id)
      _planCarrera.cursos_titulares_creados[index] = item
      dispatch({
        type: actions.GET_PLAN_CARRERA,
        payload: {
          planCarrera: _planCarrera
        },
      });
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.PLAN_CARRERA_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PLAN_CARRERA,
        payload: false,
      });
    }
  };


export const deleteCoursePlanCarreraIndividual = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_PLAN_CARRERA,
      payload: true,
    });
    debugger
    await PlanCarreraIndividualServices.deleteCursoColaborador(id);
    const { planCarrera } = getState().planCarreraIndividual;
    let _planCarrera = planCarrera
    _planCarrera.cursos_titulares_creados.splice(index, 1);
    dispatch({
      type: actions.GET_PLAN_CARRERA,
      payload: {
        planCarrera: _planCarrera
      },
    });

    dispatch({
      type: actions.PLAN_CARRERA_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.PLAN_CARRERA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_PLAN_CARRERA,
      payload: false,
    });
  }
};
